export default __webpack_public_path__ + "static/media/rectangle-gray.5b3716f9.svg";